import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { HttpUtilService } from "../http-util.service";

@Injectable({
  providedIn: "root",
})
export class DutyPulloutListService {
  private readonly baseUrl: string = "DutyPulloutService.asmx";

  constructor(private http: HttpUtilService) {}

  /**
   * Searches for duty pullout records by ETA date.
   * @param dateTimeETA The ETA date in "dd/MM/yyyy" format.
   * @returns An Observable with the API response.
   */
  searchETADate(dateTimeETA: string): Observable<any> {
    const params = `dateTimeETA=%22${encodeURIComponent(dateTimeETA)}%22`;
    return this.http.get(`${this.baseUrl}/SearchETADate?${params}`);
  }

  /**
   * Searches for duty pullout records by pullout date.
   * @param dateTime The pullout date in "dd/MM/yyyy" format.
   * @returns An Observable with the API response.
   */
  searchPulloutDate(dateTime: string): Observable<any> {
    const params = `dateTime=%22${encodeURIComponent(dateTime)}%22`;
    return this.http.get(`${this.baseUrl}/SearchPulloutDate?${params}`);
  }

  /**
   * Updates the pullout date for selected items.
   * @param payload The request body containing:
   *  - model: An array of objects with:
   *    - Name: The item identifier.
   *    - Value: The new pullout status ("0" or "1").
   *  - pullOutDate: The new pullout date in "dd/MM/yyyy" format.
   *  - moduleName: The module name (e.g., "DutyPulloutListHyundai").
   * @returns An Observable with the API response.
   */
  updatePulloutDate(payload: {
    model: { Name: string; Value: string }[];
    pullOutDate: string;
    moduleName: string;
  }): Observable<any> {
    return this.http.post(`${this.baseUrl}/UpdatePulloutDate`, payload);
  }

  /**
   * Generates and prints the duty pullout list for a given pullout date.
   * @param pulloutListDate The pullout list date in "dd/MM/yyyy" format.
   * @returns An Observable with the API response.
   */
  printDutyPulloutList(pulloutListDate: string): Observable<any> {
    const params = `PulloutlistDate=%22${encodeURIComponent(pulloutListDate)}%22`;
    return this.http.get(`${this.baseUrl}/PrintDutyPulloutList?${params}`);
  }
}
